export default {
    //安全证书连接
    itrust:function () {
        switch (location.hostname) {
            case 'www.knowsafe.com' : case 'knowsafe.com':       //正式服
                return 'https://v.itrust.cn';
            default :                       //测试服
                return 'http://itrusttest.knowsafe.com';
        }
    },
    //设置src域名的连接
    srcUrl:function () {
        switch (location.hostname) {
            case 'www.knowsafe.com' :  case 'knowsafe.com':      //正式服
                return '.src.knowsafe.com';
            default :                       //测试服
                return '.test.knowsafe.com';
        }
    }
}


// WEBPACK FOOTER //
// ./src/assets/js/url.js